export default __webpack_public_path__ + "static/media/line-bg.8227b923.png";